module.exports = __webpack_public_path__ + "static/media/AgreeFisheries29.732883cb.jpg";